import { addStyles } from 'ethcss'
import { grid, item, IStyles } from '../../theme'
import { defaultThemeStyles } from './dropMenu.theme'
import { mediaCSS } from 'blocks.app/config'

const dropMenuStyles: IStyles = {
    wrapper: {
        ...grid.w100,
        height: 42,
        ...item.rel,
    },
    icons: {
        ...grid.full,
        ...grid.row,
        ...grid.normalCenter,
        ...grid.noWrap,
    },
    listTriggerItem: {
        ...grid.fullHeight,
        ...grid.colCenter,
        ...item.relative,
        ...item.pointer,
        padding: '0 8px',

        [mediaCSS.laptop]: {
            padding: '0 4px',

            [mediaCSS.tab]: {
                padding: '0 8px',

                [mediaCSS.tabMini]: {
                    padding: '0 2px',
                },
            },
        },
    },
    arrow: {
        ...item.abs,
        top: 1,
        left: -6,
    },
    arrowAuto: {
        ...item.abs,
        bottom: 'auto !important',
        top: '100% !important',
    },
    content: {
        boxShadow: `var(--var-module-ui-component-dropMenu-style-blockShadow, ${defaultThemeStyles.blockShadow})`,
        ...item.white,
        ...item.abs,
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 99,
    },
    contentAuto: {
        top: 'calc(100% + 9px) !important',
    },
    contentGray: {
        ...item.greyLight,
    },
    controlButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 42,
        height: 42,
        border: '1px solid #D9D9D9',
        borderRadius: 8,
        marginRight: 6,
        opacity: 0.7,
        transition: 'all 0.3s',
        cursor: 'pointer',

        [mediaCSS.tab]: {
            marginTop: 8,
        },

        '&:hover': {
            boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.15)',
            opacity: 1,
        },

        '&:focus': {
            opacity: 1,
        },
    },
}

addStyles(dropMenuStyles)
export default dropMenuStyles
